import { render } from "./Forget.vue?vue&type=template&id=21a4d0c8&scoped=true"
import script from "./Forget.vue?vue&type=script&lang=js"
export * from "./Forget.vue?vue&type=script&lang=js"

import "./Forget.vue?vue&type=style&index=0&id=21a4d0c8&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-21a4d0c8"

export default script